export function getReccuringTroskoviDefinitions(reccuringTroskoviDefinitions) {
    return { type: 'GET_RECCURING_TROSKOVI_DEFINITIONS', reccuringTroskoviDefinitions };
}

export function getOneTimeGrupe(grupeOneTimeTroskova) {
    return { type: 'GET_GRUPE_ONE_TIME_TROSKOVA', grupeOneTimeTroskova };
}
